import React from 'react';
import TeamMemberProfile from './TeamMemberProfile';
import TeamMemberTile from './TeamMemberTile';
import { teamMemberData } from './teamMemberData'; // Importing the data set

const TeamMembers = () => {
  // Split members into two categories
  const coreMembers = teamMemberData.filter(
    (member) => member.memberType.toLowerCase() === 'core'
  );
  const honoraryMembers = teamMemberData.filter(
    (member) => member.memberType.toLowerCase() === 'honorary'
  );

  return (
    <div>
      <section
        id="team"
        className="team uk-section uk-overflow-hidden"
        data-uk-scrollspy="cls:uk-animation-fade; offset-top: 80px; delay: 300"
      >
        <div className="container--min uk-container uk-position-relative">
          <h3 className="team__title uk-h3">
            <span className="team__title_inner">Meet the band</span>
          </h3>

          {/* Core Members */}
          {coreMembers.length > 0 && (
            <>

              <div
                className="team__members uk-flex uk-flex-center"
                data-uk-grid
                data-uk-scrollspy="cls:uk-animation-fade; target: .team__member__wrap; delay: 300"
              >
                {coreMembers.map((member, index) => (
                  <TeamMemberTile
                    key={index}
                    name={member.name}
                    vocation={member.title}
                    memberType={member.memberType}
                    modalTarget={`#${member.name.toLowerCase().replace(/ /g, '_')}`}
                  />
                ))}
              </div>
            </>
          )}

          {/* Honorary Members */}
          {honoraryMembers.length > 0 && (
            <>
              <h4 className="team__subtitle uk-h4">Honorary Members</h4>
              <div
                className="team__members uk-flex uk-flex-center"
                data-uk-grid
                data-uk-scrollspy="cls:uk-animation-fade; target: .team__member__wrap; delay: 300"
              >
                {honoraryMembers.map((member, index) => (
                  <TeamMemberTile
                    key={index}
                    name={member.name}
                    vocation={member.title}
                    memberType={member.memberType}
                    modalTarget={`#${member.name.toLowerCase().replace(/ /g, '_')}`}
                  />
                ))}
              </div>
            </>
          )}
        </div>
      </section>

      {/* Member profiles (for modals or expanded view) */}
      {teamMemberData.map((member, index) => (
        <TeamMemberProfile
          key={index}
          name={member.name}
          title={member.subtitles}
          description={member.description}
          quote={member.quote}
          socialLinks={member.socialLinks}
           memberType={member.memberType}
        />
      ))}
    </div>
  );
};

export default TeamMembers;
